module.exports = __webpack_public_path__ + "img/CATEGORY ICON-03.c5611939.png";